"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _labels = _interopRequireDefault(require("../data/labels"));

var _default = function _default(_ref) {
  var itemThumbnail = _ref.itemThumbnail,
      itemPrice = _ref.itemPrice,
      itemTitle = _ref.itemTitle,
      itemDescription = _ref.itemDescription,
      itemNote = _ref.itemNote,
      itemLabels = _ref.itemLabels,
      labelAsImage = _ref.labelAsImage,
      itemCTALink = _ref.itemCTALink,
      imageSize = _ref.imageSize,
      itemAs = _ref.itemAs,
      align = _ref.align;

  if (itemAs === 'Item') {
    var displayImage = _react["default"].createElement(_semanticUiReact.Item.Image, {
      size: imageSize,
      src: itemThumbnail
    });

    return _react["default"].createElement(_semanticUiReact.Item.Group, null, align === 'center' && itemThumbnail && displayImage, _react["default"].createElement(_semanticUiReact.Item, null, align === 'left' && itemThumbnail && displayImage, _react["default"].createElement(_semanticUiReact.Item.Content, null, _react["default"].createElement(_semanticUiReact.Item.Header, {
      style: {
        fontSize: '1.3em',
        lineHeight: '1em'
      }
    }, itemTitle), itemDescription && _react["default"].createElement(_semanticUiReact.Item.Description, {
      style: {
        fontSize: '1em',
        lineHeight: '1.3em',
        marginTop: '0em'
      }
    }, itemDescription), itemPrice && _react["default"].createElement(_semanticUiReact.Item.Meta, {
      style: {
        fontSize: '1em',
        lineHeight: '1em',
        marginTop: '0.5em'
      }
    }, itemPrice), _react["default"].createElement(_semanticUiReact.Item.Extra, null, itemNote && _react["default"].createElement("div", {
      style: {
        fontStyle: 'italic'
      }
    }, itemNote), _react["default"].createElement("div", null, itemLabels && itemLabels.map(function (label) {
      if (labelAsImage && label in _labels["default"]) {
        return _react["default"].createElement(_semanticUiReact.Image, {
          key: label,
          size: "mini",
          src: _labels["default"][label],
          style: {
            display: 'inline-block'
          }
        });
      }

      return _react["default"].createElement(_semanticUiReact.Label, {
        key: label,
        size: "tiny"
      }, label);
    })), itemCTALink && _react["default"].createElement(_semanticUiReact.Button, {
      style: {
        marginTop: '10px'
      },
      as: "a",
      target: "_blank",
      href: itemCTALink,
      primary: true
    }, "Order Now")))));
  }

  return _react["default"].createElement(_semanticUiReact.Card, {
    fluid: true,
    centered: true
  }, itemThumbnail && _react["default"].createElement(_semanticUiReact.Image, {
    src: itemThumbnail,
    centered: true,
    fluid: true
  }), _react["default"].createElement(_semanticUiReact.Card.Content, {
    style: {
      border: 'none'
    }
  }, _react["default"].createElement(_semanticUiReact.Card.Header, {
    style: {
      fontSize: '1.5em',
      lineHeight: '1.5em'
    }
  }, itemTitle), itemPrice && _react["default"].createElement(_semanticUiReact.Card.Meta, {
    style: {
      fontSize: '1.3em',
      lineHeight: '1.3em'
    }
  }, itemPrice), itemDescription && _react["default"].createElement(_semanticUiReact.Card.Description, null, itemDescription)), (itemNote || itemLabels || itemCTALink) && _react["default"].createElement(_semanticUiReact.Card.Content, {
    style: {
      border: 'none'
    },
    extra: true
  }, itemNote && _react["default"].createElement("div", null, itemNote), _react["default"].createElement("div", null, itemLabels && itemLabels.map(function (label) {
    if (labelAsImage && label in _labels["default"]) {
      return _react["default"].createElement(_semanticUiReact.Image, {
        key: label,
        size: "mini",
        src: _labels["default"][label],
        style: {
          display: 'inline-block'
        }
      });
    }

    return _react["default"].createElement(_semanticUiReact.Label, {
      key: label,
      size: "tiny"
    }, label);
  })), itemCTALink && _react["default"].createElement(_semanticUiReact.Button, {
    style: {
      marginTop: '10px'
    },
    as: "a",
    target: "_blank",
    href: itemCTALink,
    primary: true
  }, "Order Now")));
};

exports["default"] = _default;